import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	HostBinding,
	Input,
	OnChanges,
	SimpleChange,
	ViewChild,
	ViewEncapsulation,
} from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MatLegacyInput as MatInput } from "@angular/material/legacy-input";
import { coerceBoolean, PlatformService } from "@obg/ngx.global.evo";
import { MultiDepositLimitConfig } from "@obg/ngx.ui.common";

@Component({
	selector: "obg-m-deposit-limit-item",
	templateUrl: "./deposit-limit-item.component.html",
	styleUrls: ["./deposit-limit-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class DepositLimitItemComponent implements OnChanges {
	@HostBinding("class.obg-m-deposit-limit-item") hostCssClass = true;

	@ViewChild("depositInput")
	set input(value: ElementRef<HTMLInputElement> | undefined) {
		if (!value || !this.autoFocus || !this.platformService.isBrowser || !this.isInputInit) {
			return;
		}

		setTimeout(() => value.nativeElement.focus());
	}

	currentLimitText = "";
	iconName = "";
	translationPrefix = "";
	suggestionTestId = "";

	@Input() control: UntypedFormControl | undefined;
	@Input() placeholder!: string;
	@Input() currentLimitValue: string | undefined;
	@Input() currencySymbol: string | undefined;
	@Input() limitSuggestion: string | undefined;

	@Input() @coerceBoolean() hideValidator = false;
	@Input() @coerceBoolean() autoFocus = false;
	@Input() @coerceBoolean() showInputField = false;
	@Input() @coerceBoolean() active = false;
	@Input() @coerceBoolean() prefixCurrencySymbol = false;
	@Input() @coerceBoolean() hideInputHint = false;
	@Input() sectionTitleText: string | undefined;
	depositLimitTranslationArguments: { dailyMax: number; weeklyMax: number; monthlyMax: number };

	@ViewChild("depositInput", { read: MatInput }) private matInput!: MatInput;

	@Input() set suffix(value: string) {
		this.currentLimitText = `multi-deposit-limit.current-limit.${value}`;
		this.iconName = `ico ico-deposit-limit-${value}`;
		this.translationPrefix = `multi-deposit-limit.${value}`;
		this.suggestionTestId = `deposit-limit-suggestion-${value}`;
	}

	private isInputInit = false;

	constructor(
		private platformService: PlatformService,
		private depositLimitConfig: MultiDepositLimitConfig
	) {
		this.depositLimitTranslationArguments = {
			dailyMax: this.depositLimitConfig.getDailyDepositLimitMaxValue(),
			weeklyMax: this.depositLimitConfig.getWeeklyDepositLimitMaxValue(),
			monthlyMax: this.depositLimitConfig.getMonthlyDepositLimitMaxValue(),
		};
	}

	ngOnChanges(changes: { showInputField: SimpleChange }) {
		this.isInputInit =
			changes.showInputField && changes.showInputField.currentValue && !changes.showInputField.previousValue;
		if (this.isInputInit) {
			this.matInput?.focus();
		}
	}
}
